import * as React from "react";
import {
    List,
    TextInput,
    SimpleForm,
    TextField,
    Edit,
    FunctionField,
    Datagrid,
    TopToolbar,
    Show,
    ShowButton,
    Toolbar,
    SaveButton,
    ReferenceManyField,
    required,
    NumberInput,
    TabbedShowLayout,
    DateField,
    useRecordContext,
    useGetList,
    SelectInput,
    FilterButton
} from 'react-admin';

import { RowForm } from "@react-admin/ra-editable-datagrid";
import { iconStyle } from '../shared/Styles/iconsStyles';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';
import Typography from "@material-ui/core/Typography";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Button from '@mui/material/Button';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

// Importo il css per i Bottoni
import { showButtonCss, filterButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';
import GetGraficoQuiz from '../users/GetGraficoQuiz';


/* FUNZIONI PER LA % DI AVANZAMENTO - inizio */
const PercentualeAvanzamento = ({ tblQuizId }) => {
    console.log(tblQuizId);
    const { data, loading, error } = useGetList('view-quiz-avanzamento', {
        filter: { tblQuizId: tblQuizId }
    });

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    // Verifica se data è definito e se ha almeno un elemento
    if (!data || data.length === 0) {
        return <p> - </p>;
    }

    return (
        <>
            {/* <Typography variant="subtitle1" component="div">
                <strong>Percentuale Avanzamento </strong>
            </Typography> */}
            <LinearProgressWithLabel value={data[0].percent_avanzamento} />
        </>
    );
};

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

/* FUNZIONI PER LA % DI AVANZAMENTO - fine */

const ListActions = () => (
    <TopToolbar>

        <FilterButton sx={filterButtonCss} />

    </TopToolbar>
);


export const QuizList = props => {

    return (
        <List
            pagination={null}
            title={<>
                <Button>
                    &nbsp;LISTA QUIZ
                </Button>
            </>}
            exporter={false}
            actions={<ListActions />}
            // aside={<QuizFilterSidebar />}
            filters={QuizFilters}
            {...props}
            // actions={null}
            perPage={100}
        // filters={aziendaFilters}
        >
            <Datagrid sx={listCss} bulkActionButtons={false}>
                {/*<WrapperField label="Logo Macro Area">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <CustomAvatarImage source="urlLogo" label="Logo" ></CustomAvatarImage>
                    </Box>
                </WrapperField> */}
                {<TextField source="id" ></TextField>}
                {<TextField source="usersId" ></TextField>}
                {<FunctionField source="descrizione" render={record => record && <strong>{record.descrizione}</strong>} />}
                {<FunctionField
                    source="stato" // used for sorting
                    label="Stato"
                    render={record => `${record.stato}`}
                />}
                {<FunctionField
                    source="stato" // used for sorting
                    label="Avanzamento %"
                    render={record => <PercentualeAvanzamento tblQuizId={record.id}></PercentualeAvanzamento>}
                />}

                {<DateField label="Data Creazione" source="createdAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}
                {<DateField label="Data Ultima Modifica" source="updatedAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}
                {<DateField label="Data Scadenza" source="dataScadenza" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}

                {<ShowButton sx={showButtonCss} label="Dettaglio" />}

            </Datagrid>
        </List>
    );
}

/* const ShowActions = () => (
    <TopToolbar>
        <EditButton sx={editButtonCss} label="Modifica" />
    </TopToolbar>
);
 */

const MiaRowForm = () => (
    <RowForm>
        <TextField source="id" />
        <NumberInput min={0} label="Punteggio Risposte" source="punteggioRisposte" validate={required()} />
        <NumberInput min={0} label="Valore Assegnato" source="valoreAssegnato" validate={required()} />
    </RowForm>
);

const GestioneTblQuizGraficoInShow = ({ id, ...props }) => {

    const record = useRecordContext();
    const { data, total, isLoading } = useGetList(
        'tbl-quiz',
        { filter: { usersId: record.id } }
    );
    if (!record) return null;

    console.log(record);

    return (<><Datagrid
        data={data}
        total={total}
        isLoading={isLoading}
        bulkActionButtons={false}
    >

        {data && data.length > 0 ? (
            <GetGraficoQuiz tblQuizId={data[0].id} email={record.email}></GetGraficoQuiz>
        ) : (
            <div>No data available</div>
        )}


    </Datagrid></>);

}

export const QuizShow = (props) => {
    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio Quiz
            </Button>
        </>} /* actions={<ShowActions />} */ actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                <strong>Quiz Id:</strong> <TextField source="id"></TextField>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                Descrizione: <FunctionField source="descrizione" render={record => record && `${record.descrizione}`} />
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Grafico" sx={fieldTabForShow} icon={<LeaderboardIcon sx={iconStyle} />}>
                    <Grid item xs={12}>
                        <FunctionField

                            label=""
                            render={record => <GetGraficoQuiz tblQuizId={record.id}></GetGraficoQuiz>}
                        />
                    </Grid>
                </TabbedShowLayout.Tab>


                {/*              <TabbedShowLayout.Tab label="" sx={fieldTabForShow} icon={<GpsFixedIcon sx={iconStyle} />}>
                    <Grid item xs={12}>
                    </Grid>
                </TabbedShowLayout.Tab> */}
            </TabbedShowLayout>
        </Show>
    );
}

const ShowTopToolbarDettaglio = () => (
    <TopToolbar>
        <ShowButton sx={showButtonCss} label="Dettaglio" />
    </TopToolbar>
);

const ShowActionsForEdit = () => (
    <ShowTopToolbarDettaglio></ShowTopToolbarDettaglio>
);



const QuizFilters = [
    <TextInput source="id" label="Quiz Id" />,
    <TextInput source="usersId" label="User Id" />,
    <SelectInput label="Descrizione" source="stato" choices={[
        { id: 'COMPLETATO', name: 'COMPLETATO' },
        { id: 'IN CORSO', name: 'IN CORSO' },
        { id: 'SCADUTO', name: 'SCADUTO' },
        { id: 'CREATO', name: 'CREATO' }]} />
];